var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdk1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "744px",
    height: "650px",
    viewBox: "0 0 744 650",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-42.9%",
    width: "185.7%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-42.9%",
    width: "185.7%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.1266005%",
    y1: "53.0320084%",
    x2: "6.49937184%",
    y2: "96.772292%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000002",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6758FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.1266005%",
    y1: "53.0320084%",
    x2: "6.49937184%",
    y2: "96.772292%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000002",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7FA7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StaFihub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u843D\\u5730\\u7248\\u672C1",
    transform: "translate(-597.000000, -852.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(747.000000, 1002.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-23",
    fill: "#FFD5E2",
    opacity: 0.385756341,
    filter: "url(#filter-1)",
    cx: 269,
    cy: 175,
    r: 175
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-23-Copy",
    fill: "#6758FF",
    opacity: 0.385756341,
    filter: "url(#filter-2)",
    cx: 175,
    cy: 175,
    r: 175
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(12.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17-Copy-5",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 10,
    width: 180,
    height: 180,
    rx: 22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17",
    fill: "#6758FF",
    x: 5,
    y: 0,
    width: 180,
    height: 180,
    rx: 22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-21",
    fill: "#4434E1",
    cx: 95,
    cy: 90,
    r: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(45.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#000002",
    transform: "translate(50.081750, 49.788612) rotate(-330.000000) translate(-50.081750, -49.788612) ",
    x: 45.967826,
    y: -0.211388039,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#000002",
    transform: "translate(49.788612, 50.081750) rotate(-300.000000) translate(-49.788612, -50.081750) ",
    x: 45.6746879,
    y: 0.0817500789,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#000002",
    transform: "translate(50.000000, 49.683544) rotate(-270.000000) translate(-50.000000, -49.683544) ",
    x: 45.8860759,
    y: -0.316455696,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#000002",
    transform: "translate(49.788612, 50.081750) scale(-1, 1) rotate(-300.000000) translate(-49.788612, -50.081750) ",
    x: 45.6746879,
    y: 0.0817500789,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#000002",
    transform: "translate(50.081750, 49.788612) scale(-1, 1) rotate(-330.000000) translate(-50.081750, -49.788612) ",
    x: 45.967826,
    y: -0.211388039,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-21-Copy",
    fill: "#000002",
    cx: 50,
    cy: 50,
    r: 40.5063291
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#000002",
    x: 45.5696203,
    y: 0,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-22",
    fill: "#6758FF",
    cx: 50,
    cy: 50,
    r: 30.3797468
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#000002",
    x: 45.5696203,
    y: 17.0886076,
    width: 8.2278481,
    height: 32.9113924
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#000002",
    transform: "translate(36.561178, 57.993142) rotate(-300.000000) translate(-36.561178, -57.993142) ",
    x: 32.4472535,
    y: 41.5374463,
    width: 8.2278481,
    height: 32.9113924
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#000002",
    transform: "translate(63.776367, 57.993142) scale(-1, 1) rotate(-300.000000) translate(-63.776367, -57.993142) ",
    x: 59.6624434,
    y: 41.5374463,
    width: 8.2278481,
    height: 32.9113924
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17-Copy-5",
    fill: "url(#linearGradient-4)",
    transform: "translate(328.000000, 185.000000) scale(-1, 1) translate(-328.000000, -185.000000) ",
    x: 238,
    y: 95,
    width: 180,
    height: 180,
    rx: 22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17",
    fill: "#FF7FA7",
    transform: "translate(323.000000, 175.000000) scale(-1, 1) translate(-323.000000, -175.000000) ",
    x: 233,
    y: 85,
    width: 180,
    height: 180,
    rx: 22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-21",
    fill: "#E54C87",
    transform: "translate(323.000000, 175.000000) scale(-1, 1) translate(-323.000000, -175.000000) ",
    cx: 323,
    cy: 175,
    r: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(323.000000, 175.000000) scale(-1, 1) translate(-323.000000, -175.000000) translate(273.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#FFFFFF",
    transform: "translate(50.081750, 49.788612) rotate(-330.000000) translate(-50.081750, -49.788612) ",
    x: 45.967826,
    y: -0.211388039,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#FFFFFF",
    transform: "translate(49.788612, 50.081750) rotate(-300.000000) translate(-49.788612, -50.081750) ",
    x: 45.6746879,
    y: 0.0817500789,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#FFFFFF",
    transform: "translate(50.000000, 49.683544) rotate(-270.000000) translate(-50.000000, -49.683544) ",
    x: 45.8860759,
    y: -0.316455696,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#FFFFFF",
    transform: "translate(49.788612, 50.081750) scale(-1, 1) rotate(-300.000000) translate(-49.788612, -50.081750) ",
    x: 45.6746879,
    y: 0.0817500789,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    fill: "#FFFFFF",
    transform: "translate(50.081750, 49.788612) scale(-1, 1) rotate(-330.000000) translate(-50.081750, -49.788612) ",
    x: 45.967826,
    y: -0.211388039,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-21-Copy",
    fill: "#FFFFFF",
    cx: 50,
    cy: 50,
    r: 40.5063291
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#FFFFFF",
    x: 45.5696203,
    y: 0,
    width: 8.2278481,
    height: 100,
    rx: 4.11392405
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-22",
    fill: "#FF7FA7",
    cx: 50,
    cy: 50,
    r: 30.3797468
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#FFFFFF",
    x: 45.5696203,
    y: 17.0886076,
    width: 8.2278481,
    height: 32.9113924
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#FFFFFF",
    transform: "translate(36.561178, 57.993142) rotate(-300.000000) translate(-36.561178, -57.993142) ",
    x: 32.4472535,
    y: 41.5374463,
    width: 8.2278481,
    height: 32.9113924
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    fill: "#FFFFFF",
    transform: "translate(63.776367, 57.993142) scale(-1, 1) rotate(-300.000000) translate(-63.776367, -57.993142) ",
    x: 59.6624434,
    y: 41.5374463,
    width: 8.2278481,
    height: 32.9113924
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdk1);
export default __webpack_public_path__ + "static/media/sdk1.630181f0f4d18ed8611e3eeb022c5191.svg";
export { ForwardRef as ReactComponent };